/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { reaction } from 'mobx';
import {
  Checkbox,
  Modal,
  Loader,
  Segment,
  Dimmer,
  Popup,
  Form,
  Input,
  Icon,
  List,
  Label,
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import WithRouter from '../Extensions/WithRouter';
import SettingContentsHeader from './SettingContentsHeaderByResult';
import EditScanResultModal from '../Modal/EditScanResultModal';
import EditComponentModal from '../Modal/EditComponentModal';
import api from '../../api';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';

class DefinedResultsSetting extends Component {
  constructor(props) {
    super(props);
    this.defined_setting = React.createRef();
    this.timeout = null;
    this.modalAction = null;
    this.modalBody = null;
    this.disposers = [];
    this.state = {
      isOpenMNC: false,
      isOpenMER: false,
      isOpenMEC: false,
      isModalLoader: false,
      isSort: false,
      isLoading: false,
      isCheckAll: false,
      isNextLoading: false,
      isOpenMDR: false,
      sortColumn: '7',
      componentList: [],
      sumData: {},
      resultList: [],
      checkValue: [],
      searchKeyword: '',
      pageSize: 20,
      tooltipWithType: '',
      copied: false,
      inputWidths: [],
      definedProjectList: [],
      projectPopupIndex: '',
    };
  }

  componentDidMount() {
    const { state } = this.props;
    window.addEventListener('scroll', this.handleOnScroll);
    window.addEventListener('scroll', this.setupFixedHeaders);

    if (this.defined_setting) {
      this.getDefinedResultList();
      this.adjustInputWidths();
    }

    this.disposers.push(
      reaction(
        () => {
          return state.user.localeParams;
        },
        () => {
          this.getDefinedResultList();
          this.adjustInputWidths();
        }
      )
    );

    $(document).on('mouseover', '.setting_project_content .setting_project_table .component_value', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { location } = this.props;
    const { resultList } = this.state;

    if (prevProps.location && location) {
      const currentPath = location.pathname || location;
      const prevPath = prevProps.location.pathname || prevProps.location;
      if (currentPath !== prevPath) {
        this.requiredAdmin();
      }
    }
    if (resultList.length !== prevState.resultList.length) {
      this.adjustInputWidths();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    window.removeEventListener('scroll', this.setupFixedHeaders);
    this.disposers.forEach((disposer) => {
      disposer();
    });
  }

  handleOnScroll = () => {
    const {
      getDefinedResultList,
      state: {
        error, isNextLoading, hasMore, currentPage
      },
    } = this;
    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;

    if (error || isNextLoading || !hasMore) {
      return;
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      getDefinedResultList(currentPage + 1);
    }
  };

  handleSearchChange = (value) => {
    this.setState({
      searchKeyword: value,
    });
  };

  handleModalLoader = (value) => {
    this.setState({
      isModalLoader: value,
    });
  };

  handleCheckChange = (e, { value }) => {
    this.setState((prevState) => {
      const { checkValue, resultList } = prevState;
      const isValuePresent = checkValue.includes(value);
      const newState = isValuePresent
        ? checkValue.filter((el) => { return el !== value; })
        : [...checkValue, value];

      const isCheckAll = newState.length === resultList.length;

      return {
        checkValue: newState,
        ...((isCheckAll !== prevState.isCheckAll) && { isCheckAll }),
      };
    });
  };

  handleResultCheckAll = () => {
    this.setState((prevState) => {
      const { isCheckAll, resultList } = prevState;
      return {
        isCheckAll: !isCheckAll,
        checkValue: isCheckAll ? [] : resultList.map((item) => { return item.id; }),
      };
    });
  };

  handleRemoveResult = () => {
    const { t } = this.props;
    const { checkValue } = this.state;

    if (checkValue.length === 0) {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('settings.message.select_defined_result');

      return this.setState({
        isOpenMNC: true,
      });
    }
    this.modalAction = t('modal.title.attention');
    this.modalBody = t('settings.message.delete_defined_result');

    return this.setState({
      isOpenMDR: true,
    });
  };

  handleNavigateToDetail = (rowData) => {
    const { t, navigate, state } = this.props;
    if (rowData.type === 'hash' && rowData.isUploadedFile) {
      state.report.setCustomApply(rowData);
      navigate(`/results/overview/binary/${rowData.ufid}`, {
        state: {
          fromList: true,
          currentPage: 1,
        }
      });
    } else if (rowData.type === 'component' && rowData.isUploadedFile) {
      state.report.updateSearchKeyword(rowData);
      navigate(`/results/component/binary/${rowData.ufid}`, {
        state: {
          fromList: true,
          currentPage: 1,
        }
      });
    } else {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('settings.message.already_deleted');
      this.setState({
        isOpenMNC: true,
      });
    }
  };

  handleSaveCallback = () => {
    this.setState({
      resultList: [],
      isOpenMER: false,
      isOpenMEC: false,
      componentList: [],
      sumData: {},
    }, () => {
      this.getDefinedResultList();
    });
  };

  handleCopy = (value) => {
    navigator.clipboard.writeText(value).then(() => {
      this.setState({ copied: true }, () => {
        setTimeout(() => { return this.setState({ copied: false }); }, 2000);
      });
    }).catch((err) => { return console.error('Copy failed', err); });
  };

  onChangeSearch = (value) => {
    this.setState({
      searchKeyword: value,
      resultList: [],
    }, () => {
      this.getDefinedResultList();
    });
  };

  onChangeSorting = (e) => {
    const sortColumnId = e.currentTarget.dataset.id;
    this.setState((prevState) => {
      return {
        sortColumn: sortColumnId,
        isSort: sortColumnId === prevState.sortColumn ? !prevState.isSort : false,
        resultList: [],
      };
    }, this.getDefinedResultList);
  };

  getDefinedResultList = (pageNo = 1) => {
    const { t } = this.props;
    const {
      searchKeyword, sortColumn, isSort, pageSize
    } = this.state;

    const sortOrderMappings = {
      1: isSort ? 'target' : 'target_r',
      2: isSort ? 'type' : 'type_r',
      3: isSort ? 'criterion' : 'criterion_r',
      4: isSort ? 'coverage' : 'coverage_r',
      5: isSort ? 'project_r' : 'project',
      6: isSort ? 'updater' : 'updater_r',
      7: isSort ? 'updated_r' : 'updated',
    };

    const orderText = sortOrderMappings[sortColumn] || 'updated';

    const requestData = {
      search: searchKeyword,
      page: pageNo,
      limit: pageSize,
      order: orderText,
    };

    const loadingStateKey = pageNo > 1 ? 'isNextLoading' : 'isLoading';

    this.setState({ [loadingStateKey]: true }, () => {
      api.getDefinedResultList(requestData)
        .then((response) => {
          const newResultList = response.response.map((item) => {
            return {
              id: item.user_defined_id,
              target: item.target,
              ufid: item.uploaded_file_id,
              uploadedFileName: item.uploaded_file_name,
              isUploadedFile: item.is_uploaded_file,
              updater: item.updater,
              updateAt: item.update_at,
              componentName: item.component_name,
              componentVersion: item.component_version,
              titleLicense: item.title_license,
              coverage: item.coverage,
              type: item.type,
              key1: item.key1,
              key2: item.key2,
              projectCount: item.project_count,
            };
          });

          this.setState((prevState) => {
            return {
              currentPage: response.pagination.current,
              pageSize: response.pagination.per_page,
              currentCount: response.pagination.count,
              hasMore: response.pagination.next !== null,
              [loadingStateKey]: false,
              resultList: pageNo > 1 ? [...prevState.resultList, ...newResultList] : newResultList,
            };
          });
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            error: t('modal.error.error_load'),
            [loadingStateKey]: false,
          });
        });
    });
  };

  getDefinedProjectForCustomerCompany = (id) => {
    api
      .getDefinedProjectForCustomerCompany(id)
      .then((res) => {
        const data = res.response;

        this.setState({
          projectPopupIndex: id,
          definedProjectList: data.project_list,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  setupFixedHeaders = () => {
    const contentsHeader = document.querySelector('.contents_header');
    const tableHeader = document.querySelector('.setting_table_header');
    const isScrolled = window.pageYOffset > 0;

    if (contentsHeader && tableHeader) {
      contentsHeader.classList.toggle('fixed', isScrolled);
      tableHeader.classList.toggle('fixed', isScrolled);
    }
  };

  adjustInputWidths = () => {
    const { resultList } = this.state;
    const inputWidths = resultList.map((item) => {
      const averageCharWidth = 7.3;
      const padding = 7;
      const calculatedWidth = item.key1.length * averageCharWidth + padding;
      if (calculatedWidth < 130) {
        return '130px';
      }
      return `${calculatedWidth}px`;
    });
    this.setState({ inputWidths });
  };

  createCustomerCompanyDefinedResult = async (rowData) => {
    const { t } = this.props;
    const obj = {
      user_defined_id: rowData.id,
    };

    this.setState({
      isModalLoader: true,
      isOpenMER: rowData.type === 'hash',
      isOpenMEC: rowData.type === 'component',
    });

    try {
      const response = await api.createCustomerCompanyDefinedResult(obj);
      const versionList = [{
        key: 'all', text: t('settings.list.all_versions'), value: 'all',
      }];
      const data = response.response;

      const componentList = data.components.map((row) => {
        return {
          id: uuidv4(),
          component_name: row.component_name,
          component_version: row.component_version,
          homepage: row.homepage,
          title_license: row.title_license,
          securities: row.securities,
        };
      });

      if (data.component_version) {
        const newVersion = {
          key: data.component_version, text: data.component_version, value: data.component_version,
        };
        versionList.push(newVersion);
      }

      const sumData = {
        user_defined_id: data.user_defined_id || rowData.id,
        uploaded_file_id: rowData.ufid,
        type: data.type,
        checksum: data.checksum,
        size: data.size,
        name: data.name,
        component_name: data.component_name,
        component_version: data.component_version,
        coverage: data.coverage,
        comment: data.comment,
        versionList,
      };

      this.setState({
        isModalLoader: false,
        componentList,
        sumData,
      });
    } catch (err) {
      console.log(err);
      this.setState({ isModalLoader: false });
    }
  };

  openTooltipWithType = (id) => {
    this.timeout = setTimeout(() => {
      this.setState({ tooltipWithType: id });
    }, 250);
  };

  closeTooltipWithType = () => {
    this.setState({ tooltipWithType: '' });
    clearTimeout(this.timeout);
  };

  closeProjectPopup = () => {
    this.setState({
      projectPopupIndex: '',
      definedProjectList: [],
    });
  };

  requiredAdmin = () => {
    const { state, navigate } = this.props;
    if (!state.user.isAdmin) {
      const mainPage = localStorage.getItem('main_page');
      switch (mainPage) {
      case 'dashboard':
        navigate('/main');
        break;
      case 'results':
        navigate('/results');
        break;
      default:
        navigate(`/results/${mainPage}`);
      }
    }
  };

  clearSearch = () => {
    this.setState({
      searchKeyword: '',
      resultList: [],
    }, () => {
      this.getDefinedResultList();
    });
  };

  closeModal = () => {
    this.setState({
      isOpenMNC: false,
      isOpenMDR: false,
      isOpenMEC: false,
      isOpenMER: false,
      componentList: [],
      sumData: {},
    });
  };

  formatBytes = (bytes, decimals) => {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return (
      `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`
    );
  };

  deleteResult = () => {
    const { checkValue } = this.state;
    const data = {
      user_defined_ids: checkValue,
    };

    this.setState({
      isOpenMDR: false,
      isLoading: true,
    }, () => {
      api
        .deleteDefinedResult(data)
        .then(() => {
          this.setState({
            isLoading: false,
            searchKeyword: '',
            resultList: [],
            checkValue: [],
            isCheckAll: false,
          }, () => {
            this.getDefinedResultList();
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  renderTypeValue = (type, key2) => {
    const { t } = this.props;
    if (type === 'component') {
      if (key2 === null || key2 === '') {
        return t('list.title.component');
      }
      return t('list.title.component_version');
    }
    if (type === 'hash') {
      return t('settings.list.type_hash');
    }
  };

  renderCoverageValue = (coverage) => {
    const { t } = this.props;
    if (coverage === 'company') {
      return t('modal.title.all_scans');
    }
    if (coverage === 'project') {
      return t('modal.title.scan_specific_project');
    }
  };

  renderProjectCountValue = (item) => {
    const { definedProjectList, projectPopupIndex } = this.state;
    const { coverage, projectCount, id } = item;
    if (coverage === 'company') {
      return '-';
    }
    if (coverage === 'project') {
      if (projectCount === 0) {
        return <span>{projectCount}</span>;
      }
      return (
        <Popup
          trigger={<span style={{ cursor: 'pointer' }}>{projectCount}</span>}
          on="click"
          hideOnScroll
          position="bottom left"
          style={{ marginLeft: '-16px' }}
          open={projectPopupIndex === id}
          onOpen={() => {
            return this.getDefinedProjectForCustomerCompany(id);
          }}
          onClose={this.closeProjectPopup}
        >
          <List>
            <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
              <List.List>
                {
                  definedProjectList.map((entity) => {
                    return (
                      <List.Item key={uuidv4()}>
                        <List.Icon name="folder" />
                        <List.Content>{entity}</List.Content>
                      </List.Item>
                    );
                  })
                }
              </List.List>
            </List.Item>
          </List>
        </Popup>
      );
    }
  };

  render() {
    const {
      resultList,
      sortColumn,
      isSort,
      isCheckAll,
      checkValue,
      error,
      isLoading,
      isNextLoading,
      currentCount,
      tooltipWithType,
      inputWidths,
      copied,
      searchKeyword,
      isModalLoader,
      isOpenMER,
      isOpenMEC,
      componentList,
      sumData,
      isOpenMNC,
      isOpenMDR
    } = this.state;

    const { location, state, t } = this.props;
    const pathname = location.pathname ? location.pathname : location;

    return (
      <div className="defined_setting" ref={this.defined_setting}>
        <SettingContentsHeader
          count={currentCount}
          checkValue={checkValue}
          searchKeyword={searchKeyword}
          handleRemoveResult={this.handleRemoveResult}
          handleSearchChange={this.handleSearchChange}
          onChangeSearch={this.onChangeSearch}
          clearSearch={this.clearSearch}
          location={pathname}
          state={state}
          translate={t}
        />
        <div className="setting_project_content defined">
          <div className="setting_table_header">
            <div className="setting_table_header_inner">
              <table className="setting_project_table table_header">
                <colgroup>
                  <col style={{ width: '2.25%', maxWidth: '36px' }} />
                  <col style={{ width: '12.5%', maxWidth: '200px' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '22%' }} />
                  <col style={{ width: '12%' }} />
                  <col style={{ width: '9%' }} />
                  <col style={{ width: '9%' }} />
                  <col style={{ width: '12%' }} />
                  <col style={{ width: '6.25%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <Checkbox checked={isCheckAll} onChange={this.handleResultCheckAll} />
                    </th>
                    <th>
                      <a
                        className="sorting_button"
                        data-id="1"
                        onClick={this.onChangeSorting}
                        onKeyUp={this.onChangeSorting}
                      >
                        {t('settings.list.defined_target')}
                        {isSort && sortColumn === '1' && <img src={upIcon} alt="" />}
                        {!isSort && sortColumn === '1' && <img src={downIcon} alt="" />}
                      </a>
                    </th>
                    <th>
                      <a
                        className="sorting_button"
                        data-id="2"
                        onClick={this.onChangeSorting}
                        onKeyUp={this.onChangeSorting}
                      >
                        {t('settings.list.type')}
                        {isSort && sortColumn === '2' && <img src={upIcon} alt="" />}
                        {!isSort && sortColumn === '2' && <img src={downIcon} alt="" />}
                      </a>
                    </th>
                    <th className="left">
                      <a
                        className="sorting_button"
                        data-id="3"
                        onClick={this.onChangeSorting}
                        onKeyUp={this.onChangeSorting}
                      >
                        {t('settings.list.criterion_of_change')}
                        {isSort && sortColumn === '3' && <img src={upIcon} alt="" />}
                        {!isSort && sortColumn === '3' && <img src={downIcon} alt="" />}
                      </a>
                    </th>
                    <th>
                      <a
                        className="sorting_button"
                        data-id="4"
                        onClick={this.onChangeSorting}
                        onKeyUp={this.onChangeSorting}
                      >
                        {t('settings.list.coverage')}
                        {isSort && sortColumn === '4' && <img src={upIcon} alt="" />}
                        {!isSort && sortColumn === '4' && <img src={downIcon} alt="" />}
                      </a>
                    </th>
                    <th>
                      <a
                        className="sorting_button"
                        data-id="5"
                        onClick={this.onChangeSorting}
                        onKeyUp={this.onChangeSorting}
                      >
                        {t('settings.list.applied_projects')}
                        {isSort && sortColumn === '5' && <img src={upIcon} alt="" />}
                        {!isSort && sortColumn === '5' && <img src={downIcon} alt="" />}
                      </a>
                    </th>
                    <th className="owner">
                      <a
                        className="sorting_button"
                        data-id="6"
                        onClick={this.onChangeSorting}
                        onKeyUp={this.onChangeSorting}
                      >
                        <span>{t('settings.list.last_modifier')}</span>
                        {isSort && sortColumn === '6' && <img src={upIcon} alt="" />}
                        {!isSort && sortColumn === '6' && <img src={downIcon} alt="" />}
                      </a>
                    </th>
                    <th className="created">
                      <a
                        className="sorting_button"
                        data-id="7"
                        onClick={this.onChangeSorting}
                        onKeyUp={this.onChangeSorting}
                      >
                        <span>{t('settings.list.last_modified')}</span>
                        {isSort && sortColumn === '7' && <img src={upIcon} alt="" />}
                        {!isSort && sortColumn === '7' && <img src={downIcon} alt="" />}
                      </a>
                    </th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          {
            !isLoading ? (
              <div>
                {
                  resultList.length !== 0
                    ? resultList.map((item, index) => {
                      return (
                        <div className="setting_project_table_wrap" key={item.id}>
                          <table className="setting_project_table">
                            <colgroup>
                              <col style={{ width: '2.25%', maxWidth: '36px' }} />
                              <col style={{ width: '12.5%', maxWidth: '200px' }} />
                              <col style={{ width: '15%' }} />
                              <col style={{ width: '22%' }} />
                              <col style={{ width: '12%' }} />
                              <col style={{ width: '9%' }} />
                              <col style={{ width: '9%' }} />
                              <col style={{ width: '12%' }} />
                              <col style={{ width: '6.25%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <td>
                                  <div className="content_wrapper">
                                    <Checkbox
                                      value={item.id}
                                      checked={checkValue.indexOf(item.id) > -1}
                                      onChange={this.handleCheckChange}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="content_wrapper">
                                    <span className="number">{item.target}</span>
                                  </div>
                                </td>
                                <td>
                                  <div className="content_wrapper">
                                    <Popup
                                      trigger={(
                                        <span
                                          className="has_link"
                                          onClick={() => { return this.handleNavigateToDetail(item); }}
                                          onKeyUp={() => { return this.handleNavigateToDetail(item); }}
                                        >
                                          {this.renderTypeValue(item.type, item.key2)}
                                          <span className="tooltip-icon" data-tooltip={t('list.title.more_information')}><Icon name="question" /></span>
                                        </span>
                                      )}
                                      className="wide_popup"
                                      position="bottom left"
                                      on="hover"
                                      hoverable
                                      hideOnScroll
                                      open={tooltipWithType === item.id}
                                      onOpen={() => {
                                        return this.openTooltipWithType(item.id);
                                      }}
                                      onClose={this.closeTooltipWithType}
                                    >
                                      <Form className="popup_list">
                                        <Form.Field style={{ width: inputWidths[index] || 'auto' }}>
                                          <label>
                                            {
                                              item.type === 'component' ? t('list.title.component') : t('settings.list.sha256')
                                            }
                                            <Icon
                                              className={`copy_value ${copied ? 'copied' : ''}`}
                                              name="copy outline"
                                              onClick={() => { return this.handleCopy(item.key1); }}
                                              aria-label="Copy to clipboard"
                                            />
                                            {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{t('settings.list.copied')}</span>}
                                          </label>
                                          <Input value={item.key1} readOnly />
                                        </Form.Field>
                                        {
                                          item.key2
                                          && (
                                            <Form.Field>
                                              <label>
                                                {
                                                  item.type === 'component' ? t('list.title.component_version') : t('settings.list.size')
                                                }
                                              </label>
                                              <Input value={item.type === 'component' ? item.key2 : this.formatBytes(item.key2)} readOnly />
                                            </Form.Field>
                                          )
                                        }
                                      </Form>
                                    </Popup>
                                  </div>
                                </td>
                                <td className="project_name component_detail">
                                  <div className="multiple_row">
                                    <div>
                                      <Label size="small" className="component">
                                        <Icon name="puzzle piece" />
                                        {t('list.title.component')}
                                      </Label>
                                      {
                                        item.componentName !== ''
                                      && (
                                        <Label
                                          size="small"
                                          className="component_value"
                                        >
                                          {item.componentName}
                                        </Label>
                                      )
                                      }
                                    </div>
                                    <div>
                                      <Label size="small" className="component_version">
                                        <Icon name="code branch" />
                                        {t('list.title.component_version')}
                                      </Label>
                                      {
                                        item.componentVersion !== ''
                                      && (
                                        <Label
                                          size="small"
                                          className="version_value"
                                        >
                                          {item.componentVersion}
                                        </Label>
                                      )
                                      }
                                    </div>
                                    <div>
                                      <Label size="small" className="title_license">
                                        <Icon name="balance scale" />
                                        {t('list.title.title_license')}
                                      </Label>
                                      {
                                        item.titleLicense !== ''
                                      && (
                                        <Label
                                          size="small"
                                          className="license_value"
                                        >
                                          {item.titleLicense}
                                        </Label>
                                      )
                                      }
                                    </div>
                                  </div>

                                </td>
                                <td>
                                  <div className="content_wrapper">
                                    <span className="number">{this.renderCoverageValue(item.coverage)}</span>
                                  </div>
                                </td>
                                <td>
                                  <div className="content_wrapper">
                                    <span className="number">{this.renderProjectCountValue(item)}</span>
                                  </div>
                                </td>
                                <td>
                                  <div className="content_wrapper owner">{item.updater}</div>
                                </td>
                                <td>
                                  <div className="content_wrapper created">
                                    {item.updateAt}
                                  </div>
                                </td>
                                <td>
                                  <div className="content_wrapper">
                                    <a
                                      className="edit_button"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => {
                                        this.createCustomerCompanyDefinedResult(item);
                                      }}
                                      onKeyUp={() => {
                                        this.createCustomerCompanyDefinedResult(item);
                                      }}
                                    >
                                      {t('system.button.edit')}
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      );
                    })
                    : null
                }
                {error && <div className="error_log">{error}</div>}
                {isNextLoading
                  && (
                    <Dimmer active inverted>
                      <Loader size="medium">{t('list.title.loading')}</Loader>
                    </Dimmer>
                  )}
              </div>
            ) : (
              <div>
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="large">{t('list.title.loading')}</Loader>
                  </Dimmer>
                </Segment>
              </div>
            )
          }
        </div>
        <Modal open={isOpenMNC} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={isOpenMDR} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="left_button"
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.cancel')}
                  </a>
                  <a
                    className="right_button"
                    onClick={this.deleteResult}
                    onKeyUp={this.deleteResult}
                  >
                    {t('modal.button.delete')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <EditScanResultModal
          isOpenMER={isOpenMER}
          isLoaderMER={isModalLoader}
          componentList={componentList}
          sumData={sumData}
          closeModal={this.closeModal}
          location={location}
          handleSaveCallback={this.handleSaveCallback}
          handleModalLoader={this.handleModalLoader}
          translate={t}
        />
        <EditComponentModal
          isOpenMEC={isOpenMEC}
          isLoaderMEC={isModalLoader}
          componentList={componentList}
          sumData={sumData}
          closeModal={this.closeModal}
          handleSaveCallback={this.handleSaveCallback}
          handleModalLoader={this.handleModalLoader}
          location={location}
          translate={t}
        />
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(DefinedResultsSetting))));
